import { Form } from "antd";
import Router from "../..";

export const InfluencerProfile = () => {
  const [form] = Form.useForm();

  return (
    <div>
      <h2 className="md:text-4xl text-3xl font-bold">크리에이터 정보</h2>
      <div className="flex flex-col w-full lg:flex-row lg:gap-5">
        <Router.InfluencerForm form={form} />
        <Router.BankAccntForm />
      </div>
    </div>
  );
};
